module.exports = __webpack_public_path__ + "img/step19_b_printer_basic_fix_screws.623cd2ec.png";